import MainImageCardDashboard from "../../../components/Cards/MainImageCardDashboard"
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
import { drug2 } from "../../../constants";
import DiaType from "./DiaType";
import DiaGuide from "./DiaGuide";


export default function DrugCard() {

return (
<>

    <MainImageCardDashboard

        content = {<>      
                    <HeaderCardSmall cardheadline={'Right Drug (PGx)'} /> 
                  
                </>}

        iconbuttons = {<> 
                <DiaType /> 
                <DiaGuide />             
                         
                 </>}  

        photo = { drug2 }  

    />

</>
)};
